import { yup } from '@guiker/shared-framework'

export const readAllPayoutMethodsSchema = yup.object({
  searchString: yup.string(),
})
